import Vue from 'vue'
import App from './App.vue'
import ap from './utils/axiospublic.js'
import VueRouter from 'vue-router'
import Vuex from 'vuex';
import ElementUI from 'element-ui';
import VCharts from 'v-charts'
import 'element-ui/lib/theme-chalk/index.css';
import './utils/dialogDrag'; //弹出窗口拖动
import ul from './utils/userlevel.js';
import './utils/dialogDrag.js'
import vuedraggable from 'vuedraggable';//组件拖拽顺序
import BaiduMap from 'vue-baidu-map'

Vue.use(vuedraggable)
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: window.configdata.mapkey//'cxuH9RwcFQUHXzexNS7YQR41ReMmUdmN'
})
// import signalr from './utils/signalR'
// Vue.use(signalr)
//Vue.use(dialogDrag)
Vue.use(ElementUI)
Vue.use(Vuex);
Vue.use(VCharts)
Vue.use(VueRouter)
Vue.use(ap)
Vue.prototype.$UL = ul
Vue.config.productionTip = false
const routes = [
  {
    path: '/',
    component: () => import('./pages/sys/login.vue')
  }, {
    path: '/login',
    component: () => import('./pages/sys/login.vue')
  }, {
    path: '/main',
    component: () => import('./pages/sys/main.vue'),
    redirect: '/main/welcome',
    children: [
      { name:'材料申报页',path: '/main/welcomewmdw', component: () => import('./pages/sys/welcomewmdw.vue') },
      { name:'欢迎页',path: '/main/welcome', component: () => import('./pages/sys/welcome.vue') },   
      /* { name:'相关协议',path: '/main/agreement', component: () => import('./pages/bas/agreement.vue') },
      { name:'系统参数',path: '/main/sysparament', component: () => import('./pages/bas/sysparament.vue') }, */
      { name:'组织机构',path: '/main/orgs', component: () => import('./pages/sys/orgs.vue') },
      { name:'角色定义',path: '/main/roles', component: () => import('./pages/sys/roles.vue') },
      { name:'用户管理',path: '/main/user', component: () => import('./pages/sys/user.vue') },
      { name:'操作日志',path: '/main/log',meta:{cid:'0107'}, component: () => import('./pages/bas/log.vue') },
    /*   { name:'区域管理',path: '/main/areas', component: () => import('./pages/bas/areas.vue') }, */
      { name:'权限管理',path: '/main/basicrole', meta:{cid:'0102'}, component: () => import('./pages/bas/basicrole.vue') },
      { name:'用户资料',path: '/main/basicusers', meta:{cid:'0101'}, component: () => import('./pages/bas/basicusers.vue') },
      { name:'属性定义',path: '/main/basicdata', meta:{cid:'0103'}, component: () => import('./pages/bas/basicdata.vue') },
      { name:'数据维护',path: '/main/excutesql', meta:{cid:'0104'}, component: () => import('./pages/bas/excutesql.vue') },
      { name:'评测标准',path: '/main/evaluationtypes', meta:{cid:'0105'}, component: () => import('./pages/bas/evaluationtypes.vue') },
      { name:'测评细则',path: '/main/evaluationrules', meta:{cid:'0106'}, component: () => import('./pages/bas/evaluationrules.vue') },
      { name:'创建单位列表',path: '/main/advancedunit', meta:{cid:'0302'}, component: () => import('./pages/create/advancedunit.vue') },
      { name:'创建申请',path: '/main/advancedapply', meta:{cid:'0303'}, component: () => import('./pages/create/advancedapply.vue') },
      { name:'创建审批',path: '/main/advancedapprove', meta:{cid:'0304'}, component: () => import('./pages/create/advancedapprove.vue') },
      { name:'动态日志',path: '/main/stuffquery', meta:{cid:'0401'}, component: () => import('./pages/dynamic/stuffquery.vue') },
      { name:'测评审核',path: '/main/newsapprove', meta:{cid:'0402'}, component: () => import('./pages/dynamic/newsapprove.vue') },
      { name:'单位考核',path: '/main/evalutionmarkquery', meta:{cid:'0403'}, component: () => import('./pages/dynamic/evalutionmarkquery.vue') },
      { name:'成绩查询',path: '/main/evalutionshow', meta:{cid:'0404'}, component: () => import('./pages/dynamic/evalutionshow.vue') },
      { name:'文明网材料',path: '/main/newswebsite', meta:{cid:'0405'}, component: () => import('./pages/dynamic/newswebsite.vue') },
      { name:'通知发布',path: '/main/tasks', meta:{cid:'0406'}, component: () => import('./pages/dynamic/tasks.vue') },
      { name:'通知查询',path: '/main/tasksquery', meta:{cid:'0407'}, component: () => import('./pages/dynamic/tasksquery.vue') },
      
      { name:'制定任务',path: '/main/task_send', meta:{cid:'0702'}, component: () => import('./pages/special/task_send.vue') },
      { name:'材料报送',path: '/main/task_check', meta:{cid:'0703'}, component: () => import('./pages/special/task_check.vue') },
      { name:'统计分析',path: '/main/task_query', meta:{cid:'0704'}, component: () => import('./pages/special/task_query.vue') },
      { name:'按任务完成汇总',path: '/main/task_sum', meta:{cid:'0704'}, component: () => import('./pages/special/task_sum.vue') },

      { name:'稿件类别',path: '/main/newstype', meta:{cid:'0501'}, component: () => import('./pages/news/newstype.vue') },
      { name:'稿件发布',path: '/main/newsquery', meta:{cid:'0502'}, component: () => import('./pages/news/newsquery.vue') },
      { name:'稿件查询',path: '/main/newsmanager', meta:{cid:'0503'}, component: () => import('./pages/news/newsmanager.vue') },
      { name:'按细则材料汇总',path: '/main/newsevasum', meta:{cid:'0801'}, component: () => import('./pages/rep/newsevasum.vue') },
      { name:'按单位材料汇总',path: '/main/newsunitsum', meta:{cid:'0802'}, component: () => import('./pages/rep/newsunitsum.vue') },
      { name:'志愿者组织',path: '/main/volunteerunit', meta:{cid:'0601'}, component: () => import('./pages/volunteer/volunteerunit.vue') },
      { name:'服务点单',path: '/main/volunteerneeds', meta:{cid:'0602'}, component: () => import('./pages/volunteer/volunteerneeds.vue') },
      { name:'服务派单',path: '/main/volunteeract', meta:{cid:'0603'}, component: () => import('./pages/volunteer/volunteeract.vue') },
      { name:'活动汇报',path: '/main/volunteeracto', meta:{cid:'0604'}, component: () => import('./pages/volunteer/volunteeracto.vue') },
      { name:'服务评价',path: '/main/volunteeracteva', meta:{cid:'0605'}, component: () => import('./pages/volunteer/volunteeracteva.vue') },
      { name:'用户指南',path: '/main/wmb', meta:{cid:'0901'}, component: () => import('./pages/help/wmb.vue') },
      { name:'快速入门',path: '/main/wmdw', meta:{cid:'0902'}, component: () => import('./pages/help/wmdw.vue') },
      { name:'费用支付界面',path: '/main/paypage', meta:{cid:'0902'}, component: () => import('./pages/sys/paypage.vue') },
    ]
  }]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  let nextpaths=['/main/welcome','/main/welcomewmdw','/','/login','/main','/main/paypage']
  if(nextpaths.findIndex(item=>item==to.path)>=0)
    next();
  else{
    if(ul.chklevel(to.meta.cid))
      next();
    else
      window.alert('权限不足！')
  }
});
const store = new Vuex.Store({
  currentmodule: {}
});
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
